import React, { useState, useEffect } from 'react';
import './patient.css';
import { Box, Grid, TextField, Button, MenuItem, Typography, Checkbox } from '@mui/material';
import { formatPhoneNumber } from '../../components/formatPhone';
import { FaTimes } from 'react-icons/fa'
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import * as patientActions from '../../core/Store/Actions/PatientActions';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import ValidationFunctions from '../../utils/ValidationFunctions';


const AddAdult = (props) => {
    const { onCloseModal } = props;
    const dispatch = useDispatch();
    const userData = useSelector(state => state.registerReducer.userVerifyData);
    const loading = useSelector(state => state.patientReducer.loading);
    const fhir_patient_id = userData.user?.person?.fhir_patient_id || '';
    const providerData = useSelector(
        state => state.patientReducer.validateUser,
    );
    const access_token = providerData.access_token;
    const patientDetails = useSelector(state => state.patientReducer.patientDetails);
    const { telecom, address } = patientDetails || {};
    const [invalidEmail, setInvalidEmail] = useState(false);

    const [email, setEmail] = useState('');

    // useEffect(() => {
    //     if (patientDetails) {
    //         setEmail(
    //             telecom && ((telecom[1] && telecom[1].system === 'email' && telecom[1].value) || (telecom[0] && telecom[0].system === 'email' && telecom[0].value)) ||
    //             'N/A',
    //         );
    //     }
    // }, [patientDetails]);
    const addAdultAPI = () => {
        const params = new FormData();
        params.append('patientId', providerData.id);
        params.append('email', email);
        dispatch(patientActions.addFamilyMember(params, access_token));
    };
    const handleSubmit = e => {
        e.preventDefault();
        if (email.trim().length > 0) {
            let isEmailValid = ValidationFunctions.checkIsEmailValid(
                email.trim(),
            );
            if (isEmailValid) {
                setInvalidEmail(true);
                return
            }
        }
        setInvalidEmail(false);
        addAdultAPI();
    };
    return (
        <div className='addChildModal' >
            <FaTimes style={{ height: '15%', textAlign: 'end', color: "#FFFFFF", position: 'absolute', right: 20, cursor: 'pointer' }} onClick={() => onCloseModal()} />
            <div className="paperModel">
                <Typography style={{
                    textAlign: "left",
                    fontFamily: 'Manrope',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    fontSize: 28,
                    display: "flex",
                }} component="h1" className="paperModelh1" variant="h5">
                    Add a Family Member
                </Typography>
                <div className="paperModelContent">
                    <p className='paperModelP'>
                        You can invite a family member to join. Enter thier email address and your guest will recieve an email invitation with a link to join
                    </p>
                    <form className="form" onSubmit={handleSubmit} >
                        <Grid container spacing={2} >
                            <Grid item xs={12}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="email"
                                    label="Email"
                                    name="email"
                                    variant="standard"
                                    autoComplete="email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                                {invalidEmail && <Typography color="red">Please enter valid email address</Typography>}
                            </Grid>
                            <Grid style={{ justifyContent: 'center' }} container item xs={12}>
                                <Grid item>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        className="ButtonSubmitDanger"
                                        onClick={() => onCloseModal()}
                                        disabled={loading}
                                        style={{ marginRight: '10%',fontFamily:'manrope'  }}
                                    >
                                        Close
                                </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        className="ButtonSubmit"
                                        disabled={loading}
                                        style={{fontFamily:'manrope' }}
                                    >
                                        Invite
                                </Button>
                                </Grid>
                            </Grid>
                            {/* <Grid item xs={6}>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    className="ButtonSubmitDanger"
                                    onClick={() => onCloseModal()}
                                    disabled={loading}
                                >
                                    Close
                                </Button>
                            </Grid> */}
                            {/* <Grid item xs={6}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className="ButtonSubmit"
                                    disabled={loading}
                                >
                                    Invite
                                </Button>
                            </Grid> */}
                        </Grid>

                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddAdult;